import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import axios from 'axios';

export const TrimVideo = () => {
    const [uploadedVideo, setUploadedVideo] = useState(null);
    const [trimmedVideo, setTrimmedVideo] = useState(null);
    const [startTime, setStartTime] = useState("");
    const [endTime, setEndTime] = useState("");

    const onDrop = (acceptedFiles) => {
        const formData = new FormData();
        formData.append("video", acceptedFiles[0]);


        axios
            .post(`${process.env.REACT_APP_API_URL}/upload-trim-video`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => {
                console.log('upload video');
                setUploadedVideo(response.data.filePath);
            })
            .catch((error) => {
                console.error("Error uploading video:", error);
            });
    };

    const handleTrim = () => {
        if (!startTime || !endTime || !uploadedVideo) {
            alert("Please provide start and end times and upload a video first!");
            return;
        }

        axios
            .post(`${process.env.REACT_APP_API_URL}/trim`, {
                filePath: uploadedVideo,
                startTime,
                endTime,
            })
            .then((response) => {
                setTrimmedVideo(response.data.trimmedVideoPath);
            })
            .catch((error) => {
                console.error("Error trimming video:", error);
            });
    };

    const { getRootProps, getInputProps } = useDropzone({ onDrop });

    return (
        <div style={{ padding: "20px" }}>
            <h1 style={{ textAlign: "center", padding: "20px" }}>Video Editing Tool - Trim Video</h1>
            <div
                {...getRootProps()}
                style={{
                    border: "2px dashed #888",
                    padding: "20px",
                    cursor: "pointer",
                    marginBottom: "20px",
                }}
            >
                <input {...getInputProps()} />
                <p>Drag and drop a video file here, or click to select one</p>
            </div>
            {uploadedVideo && (
                <video
                    src={`${process.env.REACT_APP_API_URL}${uploadedVideo}`}
                    controls
                    style={{ maxWidth: "50%", maxHeight:"20%", marginBottom: "20px" }}
                />
            )}
            <div>
                <label>
                    Start Time (in seconds):
                    <input
                        type="number"
                        value={startTime}
                        onChange={(e) => setStartTime(e.target.value)}
                        style={{ marginLeft: "10px" }}
                    />
                </label>
            </div>
            <div style={{ marginTop: "10px" }}>
                <label>
                    End Time (in seconds):
                    <input
                        type="number"
                        value={endTime}
                        onChange={(e) => setEndTime(e.target.value)}
                        style={{ marginLeft: "10px" }}
                    />
                </label>
            </div>
            <button
                onClick={handleTrim}
                style={{
                    marginTop: "20px",
                    padding: "10px 20px",
                    backgroundColor: "#007BFF",
                    color: "#fff",
                    border: "none",
                    cursor: "pointer",
                }}
            >
                Trim Video
            </button>
            {trimmedVideo && (
                <div style={{ marginTop: "20px" }}>
                    <h3>Trimmed Video:</h3>
                    <video
                        src={`${process.env.REACT_APP_API_URL}${trimmedVideo}`}
                        controls
                        style={{ maxWidth: "100%" }}
                    />
                    <a
                        href={`${process.env.REACT_APP_API_URL}${trimmedVideo}`}
                        download
                        style={{
                            display: "block",
                            marginTop: "10px",
                            color: "#007BFF",
                            textDecoration: "none",
                        }}
                    >
                        Download Trimmed Video
                    </a>
                </div>
            )}
        </div>
    );
}
